var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgStar = function SvgStar(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6734 1.66977C12.5474 1.41286 12.2862 1.25003 12 1.25003C11.7139 1.25003 11.4527 1.41286 11.3267 1.66977L8.50041 7.43222L2.89079 8.25803C2.61006 8.29935 2.37669 8.49557 2.28778 8.76504C2.19888 9.03451 2.26966 9.33108 2.47068 9.53135L6.67678 13.7218L5.26863 19.9241C5.20408 20.2085 5.31017 20.5045 5.54064 20.6831C5.77112 20.8616 6.08421 20.8905 6.34342 20.757L12 17.8437L17.6566 20.757C17.9158 20.8905 18.2289 20.8616 18.4594 20.6831C18.6899 20.5045 18.796 20.2085 18.7314 19.9241L17.3233 13.7218L21.5294 9.53135C21.7304 9.33108 21.8012 9.03451 21.7123 8.76504C21.6234 8.49557 21.39 8.29935 21.1093 8.25803L15.4996 7.43222L12.6734 1.66977Z",
    fill: "#22282F"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgStar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Star.225a040adcaf07c11dcef642a589a4fc.svg";